import { Col, SelectField } from '@/components';
import {
  CandidateOfInspectionByExternalExpertLabelModifier,
  type ProjectSearchFormType,
  candidateOfInspectionByExternalExpert,
} from '@/features/search/_models/projects-search';
import { COL_MIN_WIDTH } from '@/features/search/_utils/projects-search';
import { isPS } from '@/utils';
import { type FC, memo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const options = candidateOfInspectionByExternalExpert.options.map((value) => ({
  value,
  label: CandidateOfInspectionByExternalExpertLabelModifier[value],
}));

export const CandidateOfInspectionByExternalExpertColField: FC = memo(() => {
  const { t } = useTranslation();

  const {
    control,
    formState: { errors },
  } = useFormContext<ProjectSearchFormType>();
  const sheetType = useWatch({
    control,
    name: 'sheetType',
  });
  const skipAdministrativeReformTeamEvaluation = useWatch({
    control,
    name: 'skipAdministrativeReformTeamEvaluation',
  });

  if (
    isPS() ||
    sheetType !== 'RS' ||
    skipAdministrativeReformTeamEvaluation === 'true'
  ) {
    return null;
  }

  return (
    <Col span={8} style={{ minWidth: COL_MIN_WIDTH.large }}>
      <SelectField
        name="isCandidateOfInspectionByExternalExpert"
        label={t('candidate-of-inspection-by-external-expert')}
        control={control}
        errors={errors}
        options={options}
      />
    </Col>
  );
});
